import { FCX, getScaledPixels, useWindowSizeDebounced } from "@datassential/platform-ui-lib";
import { ComponentProps } from "react";
import cn from "classnames";

export enum SkeletonShape {
    Rect = 'rect',
    Circle = 'circle',
    Text = 'text',
}

type SkeletonProps = Omit<ComponentProps<'div'>, 'children'> & {
    shape?: SkeletonShape;
    width?: number;
    height?: number;
    radius?: number;
}

const Skeleton: FCX<SkeletonProps> = ({
    shape = SkeletonShape.Rect,
    width,
    height = 20,
    radius = 4,
    className,
    testId,
    style,
    ...props
}) => {
    const [wWidth] = useWindowSizeDebounced();

    const getStyles = (): React.CSSProperties => {
        const baseStyles: React.CSSProperties = {
            width: width ? getScaledPixels(width, wWidth) : '100%',
            height: getScaledPixels(height, wWidth),
        };

        if (shape === SkeletonShape.Circle) {
            return {
                ...baseStyles,
                borderRadius: '50%',
                aspectRatio: '1/1',
            };
        }

        if (shape === SkeletonShape.Text) {
            return {
                ...baseStyles,
                height: height ? getScaledPixels(height, wWidth) : '1em',
                borderRadius: getScaledPixels(radius, wWidth),
            };
        }

        return {
            ...baseStyles,
            borderRadius: getScaledPixels(radius, wWidth),
        };
    };

    return (
        <div
            className={cn("Skeleton", className)}
            data-testid={testId}
            style={{
                ...getStyles(),
                ...style,
            }}
            {...props}
        />
    );
};


export default Skeleton;
